
<div class=" flex-grow-1 position-relative h-100" *ngIf="isSpinnerLoading">
    <div class="custom-loader"></div>
</div>
<div class="flex-grow-1 d-flex flex-column"
    *ngIf="!isSpinnerLoading && (childData.type=='exam'||childData.type=='view_exam')">
    <div class="ex-cont flex-grow-1 d-flex flex-column justify-content-center">
        <div class="t-box d-flex align-items-end justify-content-center">
            <div class="me-2 mb-1">
                <img src="assets/images/object_icons/time_left.png" class="img-fluid "
                    [ngClass]="{'clock-image':countdown < 10}">
            </div>
            <div>
                <div>Left Time</div>
                <h3 class="mb-0">00:{{formattedCountdown}}</h3>
            </div>
        </div>
        <div class="mb-4 mt-3 mb-xxl-5  pt-xl-3 ex-cont">
            <div class="d-flex justify-content-between ">
                <div class="pe-2">Questions</div>
                <div class="text-bold">
                    <span class="primary-color">{{currentQueIndex < 10 ? '0' + currentQueIndex : currentQueIndex
                            }}</span>
                            <span>/{{questionArr.length}}</span>
                </div>
            </div>
            <div class="p-bar mt-1">
                <mat-progress-bar mode="determinate" class="green-gradient"
                    [value]="calculatePercentage()"></mat-progress-bar>
            </div>
        </div>

        <div class="" >
            <div class="q-cont d-flex align-items-center justify-content-center">
                <div class="q-img" *ngIf="currentQue.q_img!=''" [style.background-image]="'url(' +  currentQue.q_img + ')'">
                </div>
                <div class="q-txt text-bold">{{ currentQue.que}}</div>
            </div>
            <div class="ans-cont d-flex flex-wrap justify-content-between mt-xxl-2"
                *ngIf="currentQue.ans_t=='text'||currentQue.ans_t==''">
                <div class="ans-op mt-4 cursor-pointer" *ngIf="currentQue.op_1"
                    [ngClass]="{'selected-txt' : currentQue.ans==1}" (click)="onSelectAns(1)">
                    {{currentQue.op_1}}</div>
                <div class="ans-op mt-4 cursor-pointer" *ngIf="currentQue.op_2"
                    [ngClass]="{'selected-txt' : currentQue.ans==2}" (click)="onSelectAns(2)">
                    {{currentQue.op_2}}</div>
                <div class="ans-op mt-4 cursor-pointer" *ngIf="currentQue.op_3"
                    [ngClass]="{'selected-txt' : currentQue.ans==3}" (click)="onSelectAns(3)">
                    {{currentQue.op_3}}</div>
                <div class="ans-op mt-4 cursor-pointer" *ngIf="currentQue.op_4"
                    [ngClass]="{'selected-txt' : currentQue.ans==4}" (click)="onSelectAns(4)">
                    {{currentQue.op_4}}</div>
            </div>
            <div class="row mt-3" *ngIf="currentQue.ans_t=='image'">
                <div class="col-6 col-lg-3 column">
                    <div class="option-i cursor-pointer" (click)="onSelectAns(1)">
                        <div class="img-div bg-img" [appBackgroundImg]="currentQue.op_1"
                            [ngClass]="{'selected' : currentQue.ans==1}"></div>
                    </div>
                </div>
                <div class="col-6 col-lg-3 column">
                    <div class="option-i cursor-pointer" (click)="onSelectAns(2)">
                        <div class="img-div bg-img" [appBackgroundImg]="currentQue.op_2"
                            [ngClass]="{'selected' : currentQue.ans==2}"></div>
                    </div>
                </div>
                <div class="col-6 col-lg-3 column">
                    <div class="option-i cursor-pointer" (click)="onSelectAns(3)">
                        <div class="img-div bg-img" [appBackgroundImg]="currentQue.op_3"
                            [ngClass]="{'selected' : currentQue.ans==3}"></div>
                    </div>
                </div>
                <div class="col-6 col-lg-3 column" (click)="onSelectAns(4)">
                    <div class="option-i cursor-pointer">
                        <div class="img-div bg-img" [appBackgroundImg]="currentQue.op_4"
                            [ngClass]="{'selected' : currentQue.ans==4}"></div>
                    </div>
                </div>

            </div>
        </div>
        <div class="c-btn d-flex align-items-center justify-content-center pt-xxl-4">
            <button mat-raised-button color="primary" class="auth-form-btn mt-4 mt-lg-5 no-sh-btn" type="submit"
                (click)="nextQuestion()" [disabled]="currentQue.ans==''">
                {{ currentQueIndex < questionArr.length ? 'Next' : 'Submit' }}</button>
        </div>
    </div>

</div>

<div class="cert-box flex-grow-1 d-flex flex-column" *ngIf="!isSpinnerLoading && childData.type=='result'">
    <div class="ms-auto d-none cert-btn  d-sm-block" *ngIf="resultData.certificate && resultData.certificate!=''">
      <div *ngTemplateOutlet="certificateBtn"></div>
    </div>
    <div class="cont d-flex flex-column align-items-center mt-3 mt-sm-0">
        <div class="r-box d-box max-w flex-grow-1">
            <div *ngIf="resultData.is_p==0" style="display: contents;">
                <div class="r-up">
                    <div class="r-per text-bold d-box">{{resultData.per}}%</div>
                </div>
                <div class="r-msg mt-3 mt-lg-4 text-center">Unfortunately, You were unsuccessful</div>
            </div>
            <div *ngIf="resultData.is_p==1" class="d-flex flex-column align-items-center">
                <div class="medal">
                    <img src="assets/images/object_icons/medal_ic.png" class="img-fluid">
                </div>
                <div class="percentage d-flex text-center text-bold">{{resultData.per}}% </div>
                <div class="status text-bold text-center"> Congratulations, You have passed! </div>
            </div>
            <div class="d-flex mt-lg-4 flex-wrap align-items-center justify-content-center">
                <div class="t-box n-box d-box mt-3">
                    <div class="icon-div ms-4 me-4">
                        <img src="assets/images/object_icons/total-quest.png" class="img-fluid">
                    </div>
                    <div>
                        <h3 class="primary-color m-0">{{resultData.t_q}}</h3>
                        <div class="steel-blue">Total Question</div>
                    </div>
                </div>
                <div class="t-box  n-box d-box mt-3">
                    <div class="icon-div ms-4 me-2">
                        <img src="assets/images/object_icons/right-answer.png" class="img-fluid">
                    </div>
                    <div>
                        <h3 class="r-ans">{{resultData.r_a }}</h3>
                        <div class="steel-blue ">Right Answer</div>
                    </div>
                </div>
                <div class="t-box n-box d-box mt-3 d-flex">
                    <div class="icon-div ms-4 me-2">
                        <img src="assets/images/object_icons/wrong-answer.png" class="img-fluid">
                    </div>
                    <div>
                        <h3 class="r-wrong">{{resultData.w_a }}</h3>
                        <div class="steel-blue ">Wrong Answer</div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center  flex-wrap">
                <button type="button" class="btn btn-outline-primary me-sm-3 mt-3 mt-lg-4" (click)="onResetExam()">{{"Reset Exam" |translate}}</button>
                <div class="d-block d-sm-none mt-3 mt-lg-4" *ngIf="resultData.certificate && resultData.certificate!=''">
                    <div *ngTemplateOutlet="certificateBtn" class=""></div>
                </div>               
                <button mat-raised-button color="primary" class="auth-form-btn btn no-sh-btn mt-3 mt-lg-4" type="submit"
                    *ngIf="!isAllSectionCompleted" (click)="onNextSection()">Next Section</button>
                <button mat-raised-button color="primary" class="auth-form-btn btn no-sh-btn mt-3 mt-lg-4" type="submit"
                    *ngIf="isAllSectionCompleted" (click)="onGoToExamList()">Go to Exam List</button>
            </div>
        </div>
    </div>
</div>
<ng-template #certificateBtn>
    <button type="button" class="btn  success-btn me-sm-3 " (click)="onCertDownload(resultData.certificate)">
        <img src="assets/images/icons/download.svg" class="img-fluid me-2" alt="">{{"Certificate" |translate}}</button>
</ng-template>
